export const shiftTypes = {
  vto: 'shift_vto',
  open: 'open_shift',
};
